import { Component, ChangeDetectionStrategy } from '@angular/core'
import { AutomationEventTypes, AutomationTypes } from '@tokeet-frontend/automations'
import { UntypedFormBuilder } from '@angular/forms'
import { Store } from '@ngrx/store'
import { AutomationWizardPanelBaseComponent } from '@tv3/containers/automations/automations-wizard/automation-wizard-panel.component'
import { AccountRatesDialogService } from '@tv3/containers/rates/account-rates-dialog/account-rates-dialog.service'
import { AccountRatesDialogTab } from '@tv3/containers/rates/account-rates-dialog/account-rates-dialog.component'
import { Actions, ofType } from '@ngrx/effects'
import {
  AutomationWizardCloseAction,
  AutomationWizardSaveAction,
} from '@tv3/containers/automations/automations-wizard/automations-wizard.actions'
import { untilDestroy } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-rate-automation-wizard',
  templateUrl: './rate-automation-wizard.component.html',
  styleUrls: ['./rate-automation-wizard.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RateAutomationWizardComponent extends AutomationWizardPanelBaseComponent {
  type = AutomationTypes.Rate

  constructor(
    protected fb: UntypedFormBuilder,
    protected actions: Actions,
    protected store: Store<any>,
    private accountRatesDialog: AccountRatesDialogService
  ) {
    super(actions, store, fb)

    this.form.patchValue({ event: AutomationEventTypes.RateCreated })
  }

  ngOnInit() {
    super.ngOnInit()

    this.actions.pipe(ofType(AutomationWizardSaveAction), untilDestroy(this)).subscribe((action) => {
      if (action.closeAfterSave) {
        this.store.dispatch(AutomationWizardCloseAction())
      }
    })
  }

  onConfigure() {
    this.accountRatesDialog.open({ activeTab: AccountRatesDialogTab.RatePushAutomations })
  }
}
